/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Button,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { CustomFilterV2, DialogDefaultV2, TableV2 } from '../../../components/v2';
import * as selectorsEquipamentos from '../../../store/equipamento/reducer';
import * as actionsEquipamentos from '../../../store/equipamento/actions';
import * as Roles from '../../../constants/role';
import * as selectorsAuth from '../../../store/auth/reducer';
import Formulario from './Formulario';
import { buildEquipamentoFilter } from './helpers';

const EquipamentosV2 = ({ equipamentos, loadEquipamentos, deleteEquipamento, authData, exportEquipamento }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openExport, setOpenExport] = useState(false);
  const [localFilter, setLocalFilter] = useState({});
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    loadEquipamentos(localFilter);
  }, [loadEquipamentos]);

  const isAdmin = () =>
    authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const onEdit = (rowId) => {
    setOpen(true);
    setId(rowId);
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
  };

  const onClose = (isSave) => {
    if (isSave) {
      loadEquipamentos(localFilter);
    }
    setOpen(false);
    setId(null);
  };

  const headerActions = [];
  if (isAdmin()) {
    headerActions.push({
      label: 'Novo',
      onClick: onAdd,
      startIcon: <AddIcon />,
      variant: 'contained',
    });
    headerActions.push({
      label: 'Exportar',
      onClick: () => setOpenExport(true),
      startIcon: <FileDownloadOutlinedIcon />,
      variant: 'outlined',
    });
  }

  const columns = [
    { field: 'tipoEquipamentoNome', headerName: 'Tipo de Equipamento', flex: 0.8 },
    { field: 'numPatrimonio', headerName: 'Num. Patrimônio', flex: 0.5 },
    { field: 'modelo', headerName: 'Modelo', flex: 0.6 },
    { field: 'numSerie', headerName: 'Num. Série', flex: 0.5 },
    { field: 'codigoSisant', headerName: 'Código SISANT', flex: 0.5 },
    { field: 'codigoAnatel', headerName: 'Código ANATEL', flex: 0.5 },
    { field: 'ultimoRepasse', headerName: 'Último Repasse/Colaborador', flex: 0.8 },
    { field: 'categoriaRepasse', headerName: 'Categoria Repasse', flex: 0.5 },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Equipamentos</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={equipamentos}
          columns={columns}
          rowHeight={52}
          onEdit={isAdmin() ? onEdit : undefined}
          onDelete={isAdmin() ? deleteEquipamento : undefined}
          headerActions={headerActions}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useCodigo', codigoLabel: 'Modelo', md: 4, xs: 12 },
            { field: 'useNumPatrimonio', md: 4, xs: 12 },
            { field: 'useTipoEquipamento', md: 4, xs: 12 },
            { field: 'useNumSerie', md: 4, xs: 12 },
            { field: 'useColaborador', md: 4, xs: 12 },
            { field: 'useSisant', md: 4, xs: 12 },
            { field: 'useAtivo', md: 4, xs: 12 },
          ]}
          onFilter={(filterData) => {
            const filter = buildEquipamentoFilter(filterData);
            setLocalFilter(filter);
            loadEquipamentos(filter);
            setOpenFilter(false);
          }}
        />

        <Formulario id={id} open={open} onClose={onClose} />

        <DialogDefaultV2
          open={openExport}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            exportEquipamento(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText>
            Deseja baixar todas as informações filtradas?
          </DialogContentText>
        </DialogDefaultV2>
      </Stack>
    </Box>
  );
};

EquipamentosV2.propTypes = {
  deleteEquipamento: PropTypes.func.isRequired,
  loadEquipamentos: PropTypes.func.isRequired,
  equipamentos: PropTypes.array,
  exportEquipamento: PropTypes.func.isRequired,
  authData: PropTypes.object,
};

const mapStateToProps = (state) => ({
  equipamentos: selectorsEquipamentos.getEquipamentos(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsEquipamentos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EquipamentosV2));
